export default "__VITE_PUBLIC_ASSET__16ac5d0a__"